// =============================================================================
// Color Utils - Funzioni per colori servizi e contrasto
// =============================================================================

import { SERVICE_FALLBACK_COLORS } from './grid.constants';

/** Hash-based color per serviceDefinitionId */
export function getServiceColor(serviceId: string, serviceColor?: string | null): string {
  if (serviceColor) return serviceColor;
  let hash = 0;
  for (let i = 0; i < serviceId.length; i++) {
    hash = ((hash << 5) - hash) + serviceId.charCodeAt(i);
    hash |= 0;
  }
  return SERVICE_FALLBACK_COLORS[Math.abs(hash) % SERVICE_FALLBACK_COLORS.length];
}

/** Determina se usare testo chiaro o scuro dato un colore di sfondo */
export function getContrastTextColor(hexColor: string): string {
  const hex = hexColor.replace('#', '');
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return luminance > 0.5 ? '#1F2937' : '#FFFFFF';
}

/** Schiarisce un colore hex del fattore dato (0-1) */
export function lightenColor(hex: string, factor: number): string {
  const color = hex.replace('#', '');
  const r = parseInt(color.substring(0, 2), 16);
  const g = parseInt(color.substring(2, 4), 16);
  const b = parseInt(color.substring(4, 6), 16);
  const lighten = (c: number) => Math.round(c + (255 - c) * factor);
  return `#${lighten(r).toString(16).padStart(2, '0')}${lighten(g).toString(16).padStart(2, '0')}${lighten(b).toString(16).padStart(2, '0')}`;
}
